import { createSelector } from 'reselect'

import API from '../../api/api'

const CREATE_NEIGHBOURHOOD_PERKS = 'CREATE_NEIGHBOURHOOD_PERKS'
const SET_NEIGHBOURHOOD_PERKS = 'SET_NEIGHBOURHOOD_PERKS'
const UPDATE_NEIGHBOURHOOD_PERKS = 'UPDATE_NEIGHBOURHOOD_PERKS'
const DELETE_NEIGHBOURHOOD_PERKS = 'DELETE_NEIGHBOURHOOD_PERKS'

const initialState = {
  neighbourhoodPerks: [],
}

const neighbourhoodPerksReducer = (state = initialState, action) => {
  switch (action.type) {
    case CREATE_NEIGHBOURHOOD_PERKS: {
      return {
        ...state,
        neighbourhoodPerks: [action.neighbourhoodPerks, ...state.neighbourhoodPerks],
      }
    }
    case SET_NEIGHBOURHOOD_PERKS:
      return {
        ...state,
        neighbourhoodPerks: action.neighbourhoodPerks,
      }
    case UPDATE_NEIGHBOURHOOD_PERKS: {
      return {
        ...state,
        neighbourhoodPerks: state.neighbourhoodPerks.map((neighbourhoodPerk) => {
          if (neighbourhoodPerk.id === action.neighbourhoodPerks.id) {
            return {
              ...action.neighbourhoodPerks,
              buildingId: action.neighbourhoodPerks.buildingId.id,
            }
          } else {
            return neighbourhoodPerk
          }
        }),
      }
    }
    case DELETE_NEIGHBOURHOOD_PERKS: {
      return {
        ...state,
        neighbourhoodPerks: state.neighbourhoodPerks.filter(
          (neighbourhoodPerk) => neighbourhoodPerk.id !== action.id,
        ),
      }
    }
    default:
      return state
  }
}

export const addNeighbourhoodPerks = (perksData) => {
  return async (dispatch) => {
    const response = await API.createNeighbourhoodPerks(perksData)
    dispatch(createNeighbourhoodPerks(response.data))
    return response.data
  }
}

export const fetchNeighbourhoodPerks = (id) => {
  return (dispatch) =>
    API.getNeighbourhoodPerks(id)
      .then((res) => {
        dispatch(setNeighbourhoodPerks(res))
        return Promise.resolve()
      })
      .catch((err) => {
        return Promise.reject(err)
      })
}

export const updateNeighbourhoodPerks = (data, id) => {
  return async (dispatch) => {
    const response = await API.updateNeighbourhoodPerks(data, id)
    dispatch({ type: UPDATE_NEIGHBOURHOOD_PERKS, neighbourhoodPerks: response.data })
    return response.data
  }
}

export const deleteNeighbourhoodPerks = (id) => {
  return (dispatch) =>
    API.deleteNeighbourhoodPerks(id)
      .then((res) => {
        dispatch({ type: DELETE_NEIGHBOURHOOD_PERKS, id })
        return Promise.resolve(res)
      })
      .catch((err) => {
        return Promise.reject(err)
      })
}

const createNeighbourhoodPerks = (neighbourhoodPerks) => {
  return {
    type: CREATE_NEIGHBOURHOOD_PERKS,
    neighbourhoodPerks,
  }
}

const setNeighbourhoodPerks = (neighbourhoodPerks) => {
  return {
    type: SET_NEIGHBOURHOOD_PERKS,
    neighbourhoodPerks,
  }
}

export const selectNeighbourhoodPerks = (state) => {
  return state.organisationPlaces.neighbourhoodPerks
}

export const selectNeighbourhoodPerksById = createSelector(
  [selectNeighbourhoodPerks, (_, buildingId) => buildingId],
  (neighbourhoodPerks, buildingId) =>
    neighbourhoodPerks.filter(
      (neighbourhoodPerk) => neighbourhoodPerk.buildingId === parseInt(buildingId),
    ),
)

export default neighbourhoodPerksReducer
